import Chip from "./Chip.jsx";
import { truncate, estimatedValue, evidenceChips, scoreColor } from "../lib/format.js";

/** Compact card for the runners-up under the Decision panel. */
export default function OpportunityCard({ opportunity: o, signals, drafting, pitching, onDraft, onPitch }) {
  return (
    <div
      style={{
        background: "var(--s1)",
        border: "1px solid var(--brd)",
        borderRadius: 14,
        padding: 16,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 9 }}>
        <div
          style={{
            width: 42,
            height: 42,
            borderRadius: 11,
            border: `1.5px solid ${scoreColor(o.score)}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            style={{
              fontFamily: "var(--d)",
              fontSize: 16,
              fontWeight: 700,
              color: scoreColor(o.score),
            }}
          >
            {o.score}
          </span>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontFamily: "var(--d)", fontSize: 15, fontWeight: 600 }}>{o.company}</div>
          <div style={{ fontSize: 11, color: "var(--t3)" }}>{o.sector}</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div
            style={{ fontSize: 9, color: "var(--t3)", textTransform: "uppercase", fontWeight: 700 }}
          >
            Est. value
          </div>
          <div style={{ fontFamily: "var(--d)", fontSize: 13, fontWeight: 700 }}>
            {estimatedValue(o)}
          </div>
        </div>
      </div>

      <div style={{ display: "flex", gap: 5, marginBottom: 8, flexWrap: "wrap" }}>
        {evidenceChips(o, signals)
          .slice(0, 3)
          .map((c, i) => (
            <Chip key={i} label={c.label} color={c.color} small />
          ))}
      </div>

      <div style={{ fontSize: 13, color: "var(--t2)", lineHeight: 1.5, marginBottom: 11 }}>
        {truncate(o.why_now, 95)}
      </div>

      <div style={{ display: "flex", gap: 6 }}>
        <button
          onClick={() => onDraft(o)}
          disabled={drafting === o.id}
          style={{
            flex: 1,
            padding: 8,
            borderRadius: 7,
            border: "none",
            background: "var(--vg)",
            color: "var(--volt)",
            fontSize: 12,
            fontWeight: 600,
            fontFamily: "var(--d)",
            cursor: "pointer",
          }}
        >
          {drafting === o.id ? "…" : "Draft email"}
        </button>
        <button
          onClick={() => onPitch(o)}
          disabled={pitching === o.id}
          style={{
            padding: "8px 13px",
            borderRadius: 7,
            border: "1px solid var(--brd)",
            background: "transparent",
            color: "var(--t3)",
            fontSize: 12,
            cursor: pitching === o.id ? "wait" : "pointer",
          }}
        >
          {pitching === o.id ? "…" : "Pitch"}
        </button>
      </div>
    </div>
  );
}
